import { Image } from '@/components/ui/image/image';
import RichTextViewer from '@/components/ui/rich-text-viewer/rich-text-viewer';
import type { Document } from '@contentful/rich-text-types';
import styles from './agenda-section.module.scss';

export type AgendaCardData = {
  id: string;
  imageUrl?: string | null;
  time?: string;
  heading: string;
  subheading?: Document;
  speakerPhotoUrl?: string | null;
  speakerName?: string;
  speakerRole?: string;
};

export const AgendaCard = ({
  imageUrl,
  time,
  heading,
  subheading,
  speakerPhotoUrl,
  speakerName,
  speakerRole,
}: AgendaCardData) => {
  const hasSpeaker = speakerName || speakerPhotoUrl;

  return (
    <article className={styles.card}>
      {imageUrl && (
        <div className={styles.card_image_wrap}>
          <Image
            src={imageUrl}
            alt=""
            fill
            className={styles.card_image}
            sizes="(max-width: 640px) 100vw, (max-width: 1024px) 50vw, 25vw"
          />
        </div>
      )}
      <div className={styles.card_body}>
        <div>
          {time && <p className={styles.card_time}>{time}</p>}
          <p className={styles.card_heading}>{heading}</p>
          {subheading && (
            <div className={styles.card_subheading}>
              <RichTextViewer content={subheading} />
            </div>
          )}
        </div>

        {hasSpeaker && (
          <div className="pt-4">
            <hr className={styles.card_divider} aria-hidden />
            <div className={styles.speaker}>
              {speakerPhotoUrl && (
                <div className={styles.speaker_avatar}>
                  <Image
                    src={speakerPhotoUrl}
                    alt={speakerName ?? ''}
                    width={56}
                    height={56}
                    className={styles.speaker_avatar_img}
                  />
                </div>
              )}
              {(speakerName || speakerRole) && (
                <div className={styles.speaker_info}>
                  {speakerName && <p className={styles.speaker_name}>{speakerName}</p>}
                  {speakerRole && <p className={styles.speaker_role}>{speakerRole}</p>}
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    </article>
  );
};
